import Box from "@material-ui/core/esm/Box";
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useRecoilValue, useResetRecoilState } from 'recoil';
import { getUnpaidInvoicesForCustomer } from 'api/invoices/getUnpaidInvoicesForCustomer';
import { Title } from 'components/Text';
import useCurrentCustomer from 'hooks/customer/useCurrentCustomer';
import InvoiceList from '../InvoiceList/InvoiceList';
import { passingsForInvoicePagination } from 'api/passings/getPassingsForInvoice';
export default function UnpaidInvoices() {
  const {
    t
  } = useTranslation();
  const {
    customer
  } = useCurrentCustomer();
  const unpaidInvoices = useRecoilValue(getUnpaidInvoicesForCustomer(customer?.id));
  const resetPagination = useResetRecoilState(passingsForInvoicePagination);
  useEffect(() => {
    resetPagination();
  }, []);
  return /*#__PURE__*/React.createElement(Box, {
    mt: 2,
    position: "relative"
  }, unpaidInvoices?.totalResults === 0 ? /*#__PURE__*/React.createElement(Title, {
    align: "center"
  }, t('invoices.no_invoice')) : /*#__PURE__*/React.createElement(InvoiceList, {
    filteredResults: unpaidInvoices?.results
  }));
}